export default {
  login: { method: "post", url: "auth/ad" },
  loadSession: { method: "get", url: "load-session" },
  connectGuiche: { method: "put", url: "guiche/connect" },
  disconnectGuiche: { method: "put", url: "guiche/disconnect" },
};
